// @ts-nocheck Minified version of the Release Notes script

/**
 * Loads the Release Notes script and initializes the widget.
 *
 * @param {string} releaseToken - The JWT token for authentication with the Release Notes service.
 */
export function loadReleaseNotesScript(releaseToken: string) {
  (function (w, d, s, o, f, js, fjs) {
    w['ReleaseNotesWidget'] = o;
    w[o] =
      w[o] ||
      function () {
        (w[o].q = w[o].q || []).push(arguments);
      };
    (js = d.createElement(s)), (fjs = d.getElementsByTagName(s)[0]);
    js.id = o;
    js.src = f;
    js.async = 1;
    fjs.parentNode.insertBefore(js, fjs);
  })(
    window,
    document,
    'script',
    'rnw',
    'https://s3.amazonaws.com/cdn.releasenotes.io/v1/bootstrap.js'
  );

  // We must call window.rnw('init', { … }) before the widget script finishes
  // evaluating. (Because after load, window.rnw is replaced by the runtime API that ignores 'init'.
  // So it is important that widget script stays in the same place.

  window.rnw('init', {
    account: 'deckard-technologies.releasenotes.io',
    selector: '.rn-badge',
    /**
     * It uses the jwt token generated from /version endpoint https://github.com/deckardtech/stroracle-api/blob/f18f1baa519d7dd7b696cdd55e7321d9c56d04ac/app.py#L431 for authentication with the Release Notes service.
     * The widget is initialized only if a valid release token is available.
     *
     * @see {@link https://releasenotes.elevio.help/en/articles/87761-installing-the-popup-modal-or-banner}
     */
    jwt: releaseToken,
  });
}
